import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import { grey, red, blue, orange } from '@material-ui/core/colors';
import classNames from 'classnames';
import memobind from 'memobind';

import * as actions from '../actions';

const styles = (theme) => ({
	root: {
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'wrap',
		justifyContent: 'center',
	},
	dots: {
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'wrap',
		alignItems: 'center'
	},
	dotsHidden: {
		display: 'none'
	},
	dot: {
		width: 18,
		height: 18,
		border: `1px solid ${grey[300]}`,
		margin: '0 2px',
		borderRadius: '50%',
		backgroundColor: 'white',
		cursor: 'pointer',
		transition: 'background-color 0.2s, border-color 0.2s',
		'&:hover': {
			opacity: 0.6
		}
	},
	default: {
		'&:hover': {
			background: grey[400]
		}
	},
	selected: {
		borderColor: grey[400],
		background: grey[400],
		width: 22,
		height: 22
	},
	attempted: {
		backgroundColor: orange.A400,
		borderColor: orange.A400
	},
	correct: {
		backgroundColor: blue[400],
		borderColor: blue[400]
	},
	incorrect: {
		backgroundColor: red[400],
		borderColor: red[400]
	},
});

class DotStepper extends Component {
	constructor(props) {
		super(props);
		this.renderDot = this.renderDot.bind(this);
		this.onDotClick = this.onDotClick.bind(this);
	}

	onDotClick(i) {
		this.props.goToItem(i);
	}

	renderDot(item, i) {
		const { classes, currentItem, correctAnswers, testMode, resultsVisible, testSent } = this.props;
		const attempted = typeof correctAnswers[i] === 'boolean';

		const state = [];

		if (!resultsVisible && currentItem === i) {
			state.push(classes.selected);
		}

		if (testMode) {
			if (testSent) {
				if (correctAnswers[i]) {
					state.push(classes.correct);
				} else {
					state.push(classes.incorrect);
				}
			} else if (attempted) {
				state.push(classes.attempted);
			} else {
				state.push(classes.default);
			}
		} else if (attempted) {
			if (correctAnswers[i]) {
				state.push(classes.correct);
			} else {
				state.push(classes.incorrect);
			}
		} else {
			state.push(classes.default);
		}

		return (
			<div
				data-type="dot"
				key={`dot-${i}`}
				className={classNames(classes.dot, state)}
				onClick={memobind(this, 'onDotClick', i)}
			/>
		);
	}

	renderDots() {
		const { classes, items } = this.props;

		return (
			<div className={classes.dots}>
				{items.map(this.renderDot)}
			</div>
		);
	}

	render() {
		const { classes } = this.props;

		return (
			<div className={classes.root}>
				{this.renderDots()}
			</div>
		);
	}
}

DotStepper.propTypes = {
	classes: PropTypes.object.isRequired,
	correctAnswers: PropTypes.array.isRequired,
	currentItem: PropTypes.number,
	goToItem: PropTypes.func.isRequired,
	items: PropTypes.array.isRequired,
	resultsVisible: PropTypes.bool.isRequired,
	testMode: PropTypes.string,
	testSent: PropTypes.bool.isRequired,

};

DotStepper.defaultProps = {
	testMode: undefined,
	currentItem: null
};

const mapStateToProps = ({
	exercise: { currentItem, items, correctAnswers, resultsVisible },
	loader: { testMode, testSent }
}) => ({ currentItem, items, correctAnswers, resultsVisible, testMode, testSent });

export default compose(
	withStyles(styles),
	connect(mapStateToProps, actions)
)(DotStepper);
